import styled from 'styled-components'

const TextAreaWrap = styled.textarea`
  width: 100%;
  padding: 16px 20px;
  border: 1px solid var(--divider);
  border-radius: 3px;
  resize: none;
  line-height: 16px;
  font-family: sans-serif;
  letter-spacing: 0.1px;
`

const BaseTextArea = ({
  name,
  cols,
  rows,
  onChange,
  onBlur,
  value,
  className = '',
  ...props
}) => {
  return (
    <TextAreaWrap
      {...props}
      className={className}
      name={name}
      cols={cols}
      rows={rows}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
    ></TextAreaWrap>
  )
}

export default BaseTextArea
